import { useSelector } from 'react-redux';
import { cofaceAccessTypes } from 'shared/constants/creditReview/cofaceAccessTypes';
import { cofaceContractStates } from 'shared/constants/creditReview/cofaceContractStates';
import { useFeatures } from '../useFeatures/useFeatures';

export const useCofaceContract = () => {
  const features = useFeatures();
  const {
    cofaceContractState,
    cofaceRequestPermission,
    cofaceRequestsAllowed,
    isPending,
  } = useSelector(state => state.creditReview);

  let cofaceAccessType = cofaceAccessTypes.NO_CONTRACT_ID;
  if (cofaceContractState === cofaceContractStates.active) {
    cofaceAccessType = cofaceRequestPermission
      ? cofaceAccessTypes.REQUEST_ALLOWED
      : cofaceAccessTypes.REQUEST_NOT_ALLOWED;

    if (cofaceRequestPermission && cofaceRequestsAllowed <= 0) {
      cofaceAccessType = cofaceAccessTypes.NOT_ENOUGH_CREDITS;
    }
  }

  return { cofaceAccessType, isPending: features.creditReview ? isPending : false };
};
